import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Button, FormGroup, Label, Input,
} from "reactstrap";
import { bookingsRepo } from "data/repositories/bookingsRepo";

export default function CreateBooking() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [form, setForm] = useState({
    businessId: searchParams.get("businessId") || "",
    businessName: searchParams.get("businessName") || "",
    customerName: "",
    startDate: "",
    nights: 1,
    notes: "",
  });

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    bookingsRepo.create(form);
    navigate("/admin/bookings");
  };

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Yeni Rezervasyon</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="shadow">
              <CardHeader><h3 className="mb-0">Rezervasyon Bilgileri</h3></CardHeader>
              <CardBody>
                <form onSubmit={handleSubmit}>
                  <FormGroup>
                    <Label>İşletme Adı</Label>
                    <Input value={form.businessName} onChange={set("businessName")} required />
                  </FormGroup>
                  <FormGroup>
                    <Label>Rezervasyon Adı</Label>
                    <Input value={form.customerName} onChange={set("customerName")} required />
                  </FormGroup>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Başlangıç Tarihi</Label>
                        <Input type="date" value={form.startDate} onChange={set("startDate")} required />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label>Gece Sayısı</Label>
                        <Input type="number" min="1" value={form.nights} onChange={set("nights")} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label>Notlar</Label>
                    <Input type="textarea" value={form.notes} onChange={set("notes")} rows={3} />
                  </FormGroup>
                  <Button color="primary" type="submit">Rezervasyon Oluştur</Button>
                  <Button color="secondary" className="ml-2" onClick={() => navigate(-1)}>Vazgeç</Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
